module.exports = __webpack_public_path__ + "static/media/cloud-sun-rain-alt.e04d09db.svg";